module.exports = __webpack_public_path__ + "static/media/kirby-1.a7a111a5.jpeg";